import { getRequest, postRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export function getUserProfile() {
  return getRequest<CurrentUserSuccessResponse>('current_user');
}

export function getCsrf() {
  return getRequest<CsrfSuccessResponse>('csrf');
}

export function updateStatus(agentId: number, status: string): Promise<ApiResponse<{ message: string }>> {
  return postRequest('srs_availabilities/set_availability', { agentId, status });
}
